import React from 'react';
import { motion } from 'framer-motion';
import { Users, Zap, Briefcase, TrendingUp } from 'lucide-react';

import { PROCESS_STEPS } from '@utils/constants';
import * as Icons from 'lucide-react';

const Process = () => {
  return (
    <section id="process" className="py-24 bg-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <h2 className="text-4xl font-bold text-slate-900 mb-4">Your Journey to Success</h2>
          <p className="text-xl text-slate-600">A proven 4-step process designed to get you hired in 4-8 weeks.</p>
        </motion.div>

        <div className="relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-1 bg-gradient-to-r from-indigo-200 via-violet-200 to-indigo-200 -translate-y-1/2" />

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {PROCESS_STEPS.map((item, idx) => {
              const IconComponent = Icons[item.icon] || Icons.HelpCircle;
              return (
                <motion.div
                key={item.step}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: idx * 0.15 }}
                className="relative"
              >
                <div className="bg-white rounded-3xl p-6 border-2 border-slate-100 hover:border-indigo-200 transition-colors shadow-lg shadow-slate-100/50 relative z-10">
                  <div className="w-12 h-12 bg-indigo-600 rounded-xl flex items-center justify-center text-white font-bold text-lg mb-4 shadow-lg shadow-indigo-600/25">
                    {item.step}
                  </div>
                  <IconComponent className="w-6 h-6 text-indigo-600 mb-3" />
                  <h3 className="text-lg font-bold text-slate-900 mb-2">{item.title}</h3>
                  <p className="text-slate-600 text-sm">{item.description}</p>
                </div>
              </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
